/*
 * @Description: 初始项目基础数据
 * @Date: 2023-09-11 19:31:47
 */
import store from '../store';

export default async to => {
  // await会导致v3项目加载异常，找不到挂在节点
  /* 
     application 'v3' died in status LOADING_SOURCE_CODE: [qiankun]: Target container with #subapp-container not existed while v3 loading
  */
  if (!to.path.includes('/v3/')) {
    await store.dispatch('bank/setBanks');
  }
};
